// Clean this code after 15. 12. 2023.
// Wait so all the carts get to v3 and then remove support for v1.
// If v1 => empty the cart. This will be the final step of this big update.

/*
____________________________
 
  @CartManager
____________________________
 
  Operations on cart.
 
*/

CartManager = {}
CartManager.v2 = {}
CartManager.addToCart = {}
CartManager.qty = {}
CartManager.cart = {}
CartManager.cartShaman = {}
CartManager.product = {}
CartManager.firstLoad = {}
CartManager.changeQty = {}
CartManager.cartAjax = {jobsDone: []}
CartManager.getCart = {counter: 0, orphansCleared: false}

CartManager.settings = {
  targetCartVersion: 3,      // Gracefully try to make a cart of this version.
  passedCartVersion: null    // This version will be stored in next cart change.
}

CartManager.getCart.onLoad = function(cart, onSuccess) {
  
  CartManager.getCart.counter += 1  
  CartManager.getCart.save(cart)
  //CartManager.firstLoad.emptyOldCart()
  CartManager.handleCartVersion()
  
  $('body').trigger('lastCartUpdated')  // for cart page

  if (typeof onSuccess === "function") {
    onSuccess(cart)
  }
}

CartManager.handleCartVersion = function() {

  // Set a new version here and cart will gracefully upgrade itself :)
  CartManager.settings.passedCartVersion = CartManager.cartVersionInCart()

  if (CartManager.settings.passedCartVersion != CartManager.settings.targetCartVersion && CartManager.isCartEmpty())
    CartManager.settings.passedCartVersion = CartManager.settings.targetCartVersion

  // console.log('Current Cart version:', CartManager.cartVersionInCart(), 'Passed Cart version:', CartManager.settings.passedCartVersion)
}

CartManager.cartVersionInCart = function() {
  let version = parseFloat(CartManager.lastCart.attributes._cart_version)
  if (!version || typeof version != 'number' || isNaN(version)) version = 1
  return version
}

CartManager.isCartEmpty = function() {
  return CartManager.lastCart.items.length == 0
}

CartManager.listAllEngravings = function() {
  CartManager.lastCart.items.filter(item => item.sku == 'GRAVURA').forEach(item => console.log(item.properties_all))
}

CartManager.getCart.save = function(cart) {
  cart.items.forEach(item => item.properties_all = {...item.properties})
  CartManager.lastCart = {...cart} //fix Danger! This is not a deep copy!
}

CartManager.fixCart = function(cart) {
  cart = CartManager.propertiesToHtml(cart)       // Build properties HTML for the Drawer
  cart.items = CartManager.addEngravingPriceToProduct(cart.items)
  return cart
}

//fix
CartManager.isKeyInCart = function(key) {
  let list = CartManager.lastCart.items.filter(item => item.key == key)
  return list.length > 0
}

// Not in use? //fix
CartManager.removeEngravings = function(items) {
  return items.filter(item => !CartManager.isItemEngraving(item))
}

// Make HTML out of properties
// eg: Engraving: "Text" -> <div>Engraving: Text</div>
CartManager.propertiesToHtml = function(cart) {
  let translation = $('#translation_engraving_text').text()
  
  cart.items.forEach(item => {
    item.properties_formatted = ''
    let engravingIndex = 1

    for (let key in item.properties || {}) {
      if (key.charAt(0) == '_') continue

      let val = item.properties[key]
      let thisIsEngraving = key.split(' '+engravingIndex)[0] == translation
     
      if (thisIsEngraving) {
        let indexString = engravingIndex == 1 ? '' : '_' + engravingIndex
        let font = Engravings.findCurrentFontFamily(item.properties['_engraving_data'+indexString].split('&')[0])
        let text = item.properties['_engraving_data'+indexString].split('&txt=')[1] || ''
        val = `<span style="font-family: ${font}">${text}</span>`
        engravingIndex += 1
      }
      
      item.properties_formatted += `<div class="cart_drawer_property">${key}: ${val}</div>`
    }
  })
  
  return cart
}

CartManager.addEngravingPriceToProduct = function(items) {
    
    function addPriceToItem(item) {
      item.price += CartManager.engravingPriceForItem(item.key, items)
      let cPrice = item.properties_all._compare_at_price
      if (cPrice && (cPrice+'').includes('|||')) { // fix - remove second part after 20.8.
        let compareAtPrice = parseInt(cPrice.split('|||')[0])
        let saving = cPrice.split('|||')[1]
        let newPrice = CartManager.engravingPriceForItem(item.key, items) + compareAtPrice
        item.properties_all._compare_at_price = newPrice + '|||' + saving
      }
    }
    let itemsNotEngraving = items.filter(item => !CartManager.isEngravingId(item.id))
  
    itemsNotEngraving.forEach(item => addPriceToItem(item))
    return items
}

// When big updates are made to the cart functionality, sometimes old carts
// need to be emptied, because the new code will not work properly with them.
CartManager.firstLoad.emptyOldCart = function() {
 
  if (CartManager.getCart.counter == 1 && CartManager.cartVersionInCart() == undefined && !CartManager.isCartEmpty()) {
    return CartManager.emptyCart()
  }

  return Promise.resolve()
}

CartManager.emptyCart = function() {
  let data = {updates: {}}

  CartManager.lastCart.items?.forEach(item => {
    data.updates[item.key] = 0
  })

  if (Object.keys(data.updates).length == 0)
    return Promise.resolve()
  
  return $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      console.log('Cart has been emptied.')
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('ERROR: Cart could not be emptied.')
    }
  })  
}

CartManager.isEngravingId = function(id) {
  return ENGRAVING_PRODUCT_IDS.includes(id)
}

CartManager.isItemEngraving = function(item) {
  return ENGRAVING_PRODUCT_IDS.includes(item.variant_id)
}

// Cart update (on qty change)
// If item has engaving attached to it, then the engraving is added to updateObj - updateObj is sent to shopify via ajax
CartManager.addChildEngraving = function(parentKey, updateObj, qty) {
  for (let item of CartManager.lastCart.items) {
    if (CartManager.isItemEngraving(item) && item.properties_all?._parent_key == parentKey)
        updateObj[item.key] = qty    // Set new quantity for engraving
  }

  return updateObj
}

CartManager.engravingHasParent = function(engraving) {
  let parents = CartManager.lastCart.items.filter(item => item.key == engraving.properties_all?._parent_key)
  return parents.length > 0
}

CartManager.getChildEngravings = function(parentKey) {
  let engravings = []
  for (let item of CartManager.lastCart.items)
    CartManager.isItemEngraving(item) && item.properties_all?._parent_key == parentKey && engravings.push(item)

  return engravings
}

// Returns price of engraving that is attached to the parent item
CartManager.engravingPriceForItem = function(parentKey, items) {
    if (CartManager.settings.passedCartVersion == 3) {
      return CartManager.v2.engravingPriceForItem(parentKey, items)
    }
  
    let sum = 0
    items.forEach(item => {
      if (item.properties_all?._parent_key == parentKey) sum += item.price
    })
    return sum
}


///////////////////////////////////////////
// Single ajax call for cart add
///////////////////////////////////////////


    // Here gets stored what needs to be updated and what needs to be added.
    // Why would we add a product when user changes quantity of an existing product?
    // Maybe user changed cart in multiple tabs and for some reason engraving disappeared from the cart.
    // This is where it's added back.
    CartManager.changeQty.quantityObject = {
      update: null,
      add: null
    }

    // First updates the product (on btn click)
    // Then update/add all engravings
    // This also fixes the qunatity missmatches and engraving orphans
    CartManager.changeQty.buildQuantityObject = function(currentProduct) {
      
      let updates = {}
      let add = {items: []}
      updates[currentProduct.productKey] = currentProduct.qty
     
      // Build a temp object of products where the updated product already has the new quantity
      let products = CartManager.cart.getProducts()
      products.find(item => item.key == currentProduct.productKey).quantity = currentProduct.qty

      CartManager.cartShaman.collectAllEngravingIds().forEach(engravingId => {

        let newEngravingQty = CartManager.cartShaman.getCumulativeChildEngravingQty(engravingId, products)
        let engraving = CartManager.cart.itemById(engravingId)
        
        // Update existing engraving
        if (engraving) updates[engraving.key] = newEngravingQty

        // Or add a new one
        else if (newEngravingQty > 0) add.items.push({ id: id, quantity: newEngravingQty })
      })
      
      CartManager.changeQty.quantityObject.update = {updates: updates}
      CartManager.changeQty.quantityObject.add = add
    }
    
    CartManager.changeQty.addCartItemsAjax = function() {
      if (CartManager.changeQty.quantityObject.add.items.length > 0) {
        console.log('ADD:', CartManager.changeQty.quantityObject.add)
        return $.ajax({ type: 'POST', url: '/cart/add.js', data: CartManager.changeQty.quantityObject.add, dataType: 'json' })
      }
      else {
        console.log('ADD: Skip')
        return Promise.resolve()
      }
    }
   
    CartManager.product.getEngravingIds = function(product) {
      let ids = []
      product.properties?._engraving_ids?.forEach(id => ids.push(id))
      return ids
    }
  
    CartManager.product.hasEngraving = function(product) {
      return CartManager.product.getEngravingIds(product).length > 0
    }

    CartManager.product.hasEngravingId = function(product, id) {
      return CartManager.product.getEngravingIds(product).contains(id+'')
    }

    CartManager.cart.getEngravings = function(cart) {
      cart = cart || CartManager.lastCart
      return cart.items.filter(item => item.sku == 'GRAVURA')
    }

    CartManager.cart.getProducts = function() {
      return CartManager.lastCart.items.filter(item => item.sku != 'GRAVURA')
    }

    CartManager.cart.itemByKey = function(key) {
      return CartManager.lastCart.items.find(item => item.key == key)
    }
    
    CartManager.cart.itemById = function(id) {
      return CartManager.lastCart.items.find(item => item.id == id)
    }
    
    CartManager.qty.diffOldNew = function(itemKey, newQty) {
      let thisItemFromCart = CartManager.cart.itemByKey(itemKey) 
      let oldQty = thisItemFromCart?.quantity || newQty
      return newQty - oldQty
    }

    CartManager.cartAjax.add = function(data) {
      if (!data.items.length) return Promise.resolve()
      CartManager.cartAjax.jobsDone.push('add')
      return $.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json' })
    }

    CartManager.cartAjax.update = function(update) {
      if ($.isEmptyObject(update.updates)) return Promise.resolve()
      CartManager.cartAjax.jobsDone.push('update')
      return $.ajax({ type: 'POST', url: '/cart/update.js', data: update, dataType: 'json' })
    }

    CartManager.engravingParents = function(engraving) {
     
      let parents = CartManager.lastCart.items.filter(item => {
        return CartManager.product.getEngravingIds(item).includes(engraving.id+'')
      })
      return parents
    }  

// *** cartShaman *** //
// Inspired by cartDoctor
// Special functions that fix problems with changing quantites in multiple tabs.
// Multiple tabs are tricky. A doctor is not enough here. This calls for a shaman.

// All products that have the same engraving => sum the quantites.
CartManager.cartShaman.getCumulativeChildEngravingQty = function(engravingId, products) {
  let qty = 0 
  products.forEach(item => {
    if (CartManager.product.hasEngravingId(item, engravingId)) qty += item.quantity
  })
  return qty
}

// Collect all engraving ids from engravings products in cart and engraving children attached to products
CartManager.cartShaman.collectAllEngravingIds = function() {
  let ids = new Set()
  
  CartManager.lastCart.items.forEach(item => {
    CartManager.product.getEngravingIds(item).forEach(id => ids.add(parseInt(id)))
    if (item.sku == 'GRAVURA') ids.add(item.id)
  })

  return ids
}

// Returns price of engraving that is attached to the parent item
// Item can have more than 1 engraving
CartManager.v2.engravingPriceForItem = function(parentKey, cartItems) {
  let sum = 0
  let productItem = CartManager.cart.itemByKey(parentKey)
  let engravingIds = CartManager.product.getEngravingIds(productItem)
  engravingIds.forEach(engravingId => {
    cartItems.forEach(item => {
      if (item.id == engravingId) sum += item.price
    })
  })
  return sum
}


class CartShaman {
  constructor() {
    this.onlineCart = CartManager.lastCart
    this.virtualCart = jQuery.extend(true, {}, this.onlineCart);
  }

  addItem(item) {
    item.change = 'add'
    this.virtualCart.items.push(item)
  }

  updateItem(key, quantity) {
    let item = this.virtualCart.items.find(i => i.key == key)
    if (item) {
      item.change = 'update'
      item.quantity = Math.max(quantity, 0)
    }
  }

  idExists(id) {
    return !!this.virtualCart.items.find(item => item.id == id)
  }
  
  // Find product/engraving missmatches and fix them. Changes are entirely made on virtualCart.
  // The result is an end image of what the final cart should look like.

  // 1) collect engravings in products via _engraving_ids to qtyMap
  // 2) each engraving in cart
  // 	- if has no parent -> set qty = 0
  // 	- else => update qty to the right value
  // 3) engravings that should be in cart but are missing -> add them

  fixCart() {

    let qtyMap = {}
    let updates = {}
    
    // 1)
    // How many engravings do the products have?
    // First collect products with engraving and build a map {engravingid: qty}
    
    this.virtualCart.items.forEach(item => {
      let engravingIds = CartManager.product.getEngravingIds(item)
      engravingIds.forEach(engravingId => {
        qtyMap[engravingId] = (qtyMap[engravingId] || 0) + item.quantity
      })
    })

    // 2)
    // How many engravings are actually in cart?
    // Update when qty of engraving doesn't match quantity of products
    
    CartManager.cart.getEngravings(this.virtualCart).forEach(engraving => {

      // Engraving has no parent product
      if (qtyMap[engraving.id] == undefined) {
        this.updateItem(engraving.key, 0)
      }
      // Match quantities
      else {
        this.updateItem(engraving.key, qtyMap[engraving.id])
      }
    })

    // 3)
    // In case an engraving is missing, add it
    Object.keys(qtyMap).forEach(id => {
      if (!this.idExists(id)) this.addItem({id: id, quantity: qtyMap[id]})
    })

  }
  
  // Extract changes made to the cart. This will be send to API via add and update endpoints.
  getChanges() {
    let changes = {
      added: [],
      updated: {}
    }

    this.virtualCart.items.forEach(item => {
      if (item.change == 'add') changes.added.push(item)
      if (item.change == 'update') changes.updated[item.key] = item.quantity
    })

    return changes
  }
}


// One function for all - add a product or update a product (in drawer or on cart page)
CartManager.v2.changeCart = function(data) {

  //
  // First prepare data for cart/add and cart/update
  //
  
  let cartShaman = new CartShaman()

  data.add?.forEach(item => cartShaman.addItem(item))

  data.update?.forEach(item => cartShaman.updateItem(item.key, item.quantity))

  cartShaman.fixCart()

  let changes = cartShaman.getChanges()

  let defaultData = {
    utf8: '✓',
    attributes: {'_engraving_version': '2.1', '_cart_version': CartManager.settings.passedCartVersion}    
  }

  let addData = {...defaultData, items: changes.added}
  let updateData = {...defaultData, updates: changes.updated}

  //
  // Then make the ajax calls
  //
  
  CartManager.cartAjax.jobsDone = []
  
  return CartManager.cartAjax.add(addData).then(function () {
    
    return CartManager.cartAjax.update(updateData)
    
  }).then(function() {

    // console.log('CART SHAMAN done', CartManager.cartAjax.jobsDone.join(' and '))
    
  })
}
